define('adminWorkActivityListView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'moment',
  'windows',
  'adminWorkActivityDetailPopupView',
  'template!adminWorkActivityListTpl',
  'entities/admin/work_activity'
], function (
  Module,
  App,
  _,
  $,
  Marionette,
  moment,
  Windows,
  DetailPopupView,
  tpl
) {
  'use strict';

  // Hard-coded list of status codes featured in the "Top movers" panel.
  // We don't filter by commandType — a move into any of these statuses
  // counts regardless of whether it happened on an offer or an order.
  var TOP_MOVERS_STATUSES = ['PSDONE', 'EMAILSEQ', 'MODIFDONE', 'MODIFSEQ'];
  var TOP_MOVERS_PER_GROUP = 5;

  Module.exports = Marionette.ItemView.extend({
    template: tpl,
    className: 'admin-work-activity-view',

    ui: {
      from: '.js-from',
      to: '.js-to',
      apply: '.js-apply',
      presets: '.js-preset',
      rows: '.js-row'
    },

    events: {
      'click @ui.apply': 'onApply',
      'click @ui.presets': 'onPreset',
      'click @ui.rows': 'onRowClick'
    },

    initialize: function () {
      this.canView = null;
      this.preset = '7d';
      this.applyPreset('7d', { silent: true });
      this.rows = [];
      this.topMoversGroups = [];
      this.kpis = this.emptyKpis();
    },

    emptyKpis: function () {
      return {
        totalHours: '0',
        activeUsers: '0',
        avgHoursPerUser: '0'
      };
    },

    serializeData: function () {
      return {
        canView: this.canView !== false,
        preset: this.preset,
        fromValue: this.from.format('YYYY-MM-DD'),
        toValue: this.to.format('YYYY-MM-DD'),
        rows: this.rows,
        topMoversGroups: this.topMoversGroups,
        kpis: this.kpis,
        // Kept in the template only because the row markup highlights the
        // currently-open popup row. We don't track it anymore — always null.
        selectedUserSecId: null
      };
    },

    onShow: function () {
      var that = this;
      App.request('workActivity:canView').done(function (canView) {
        that.canView = canView === true;
        if (!that.canView) {
          that.render();
          return;
        }
        that.refresh();
      });
    },

    applyPreset: function (preset, opts) {
      var now = moment();
      switch (preset) {
        case 'today':
          this.from = now.clone().startOf('day');
          this.to = now.clone().endOf('day');
          break;
        case 'month':
          this.from = now.clone().startOf('month');
          this.to = now.clone().endOf('day');
          break;
        case '30d':
          this.from = now.clone().subtract(30, 'days').startOf('day');
          this.to = now.clone().endOf('day');
          break;
        case '7d':
          this.from = now.clone().subtract(7, 'days').startOf('day');
          this.to = now.clone().endOf('day');
          break;
        default:
          preset = '7d';
          this.from = now.clone().subtract(7, 'days').startOf('day');
          this.to = now.clone().endOf('day');
          break;
      }
      this.preset = preset;
      if (!opts || !opts.silent) {
        this.refresh();
      }
    },

    onPreset: function (e) {
      var preset = $(e.currentTarget).data('preset');
      this.applyPreset(preset);
    },

    onApply: function () {
      var fromVal = this.ui.from.val();
      var toVal = this.ui.to.val();
      if (fromVal) { this.from = moment(fromVal, 'YYYY-MM-DD').startOf('day'); }
      if (toVal)   { this.to   = moment(toVal,   'YYYY-MM-DD').endOf('day'); }
      this.preset = 'custom';
      this.refresh();
    },

    refresh: function () {
      var that = this;
      var fromMs = this.from.valueOf();
      var toMs = this.to.valueOf();

      App.request('workActivity:totals', fromMs, toMs).done(function (totals) {
        that.rows = that.computePeopleRows(totals);
        that.kpis = that.computeKpis(totals);
        that.render();
        that.fetchTopMovers();
      });
    },

    computePeopleRows: function (totals) {
      var maxMinutes = _.max(_.pluck(totals, 'totalMinutes')) || 1;
      return _.map(totals, function (row) {
        var first = (row.firstName || '').trim();
        var last = (row.lastName || '').trim();
        var fullName = (first + ' ' + last).trim() ||
                       (row.logonId || row.email || '?');
        var initials = ((first ? first.charAt(0) : '') +
                        (last ? last.charAt(0) : '')).toUpperCase() ||
                       (row.logonId || '?').charAt(0).toUpperCase();
        var totalHours = (row.totalMinutes / 60).toFixed(1);
        var barPct = Math.round((row.totalMinutes / maxMinutes) * 100);
        var lastSeen = row.lastSeen ? moment(row.lastSeen) : null;
        return _.extend({}, row, {
          fullName: fullName,
          initials: initials,
          handle: row.logonId || row.email || '',
          totalHours: totalHours,
          barPct: barPct,
          lastSeenLabel: lastSeen ? lastSeen.fromNow() : '—',
          lastSeenFull: lastSeen ? lastSeen.format('YYYY-MM-DD HH:mm') : ''
        });
      });
    },

    computeKpis: function (totals) {
      var totalMinutes = _.reduce(totals, function (acc, r) {
        return acc + (r.totalMinutes || 0);
      }, 0);
      var activeUsers = totals.length;
      var avgMinutes = activeUsers > 0 ? totalMinutes / activeUsers : 0;
      return {
        totalHours: this.formatHours(totalMinutes),
        activeUsers: String(activeUsers),
        avgHoursPerUser: this.formatHours(Math.round(avgMinutes))
      };
    },

    fetchTopMovers: function () {
      var that = this;
      var fromMs = this.from.valueOf();
      var toMs = this.to.valueOf();

      // One top-movers call per featured status code. commandType is
      // intentionally left undefined so a move into the status is counted
      // whether it happened on an offer or an order.
      var promises = _.map(TOP_MOVERS_STATUSES, function (statusCode) {
        return App.request('workActivity:top-movers',
          fromMs, toMs, statusCode, null, TOP_MOVERS_PER_GROUP);
      });

      $.when.apply($, promises).done(function () {
        var moverResults = _.toArray(arguments);
        // $.when resolves a single deferred as the value directly, not as
        // an args array — normalize so the single-status case still works.
        if (TOP_MOVERS_STATUSES.length === 1) {
          moverResults = [moverResults];
        }

        that.topMoversGroups = _.map(TOP_MOVERS_STATUSES, function (statusCode, i) {
          return {
            commandType: '',
            commandTypeClass: '',
            status: statusCode,
            movers: moverResults[i] || []
          };
        });

        that.render();
      });
    },

    onRowClick: function (e) {
      var userpidSecId = $(e.currentTarget).data('userpid-sec-id');
      if (!userpidSecId) { return; }

      var row = _.findWhere(this.rows, { userpidSecId: userpidSecId });
      if (!row) { return; }

      var from = this.from.clone();
      var to = this.to.clone();

      Windows.open({
        view: function () {
          return new DetailPopupView({
            userpidSecId: userpidSecId,
            fullName: row.fullName,
            handle: row.handle,
            initials: row.initials,
            from: from,
            to: to,
            totalMinutesFromList: row.totalMinutes,
            activeDaysFromList: row.activeDays
          });
        },
        title: row.fullName,
        width: 880,
        height: 620,
        modal: true
      });
    },

    formatHours: function (totalMinutes) {
      if (!totalMinutes) { return '0h'; }
      var h = Math.floor(totalMinutes / 60);
      var m = totalMinutes % 60;
      if (h === 0) { return m + 'm'; }
      if (m === 0) { return h + 'h'; }
      return h + 'h ' + (m < 10 ? '0' + m : m) + 'm';
    },

    formatNumber: function (n) {
      if (n === null || n === undefined) { return '0'; }
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  });
});

